import http from '@axios'

export function postAttachment(data) {
  return http({
    method: 'POST',
    url: 'files/attachments/',
    data,
  })
}

export function deleteAttachment(id) {
  return http({
    method: 'DELETE',
    url: `files/attachments/${id}/`,
  })
}

export function getSingleAttachment(id) {
  return http({
    method: 'GET',
    url: `files/attachments/${id}`,
  })
}
